import { DataStore } from "shared_critical/store";
import { mapObject } from "underscore";

const keys = {
  clientId: 'google_maps_client_id',
  apiKey: 'google_maps_api_key',
  version: 'google_maps_version',
  channel: 'google_map_api_channel',
  environment: 'google_maps_environment'
};

export const rawMapConfig = DataStore.getData('mapConfiguration');

const getConfig = () => {
  if (rawMapConfig)
    return mapObject(keys, (key) => rawMapConfig[key]);
};

export const config = getConfig();



// WEBPACK FOOTER //
// ./maps/config.js